import angular from 'angular';

class registrationRequestDetailCtrl {

    /* @ngInject */
    constructor($window) {
        this.$window = $window;
    }

    cancel() {
        this.$window.history.back();
    }
    


}


angular.module('app.registration_request').component('registrationRequestDetail', {
    templateUrl: require('./registration-request-detail.html'),
    controller: registrationRequestDetailCtrl,
    bindings: {
        registrationRequestBo: '<',
    },
});
